import { render, staticRenderFns } from "./RiskComponent.vue?vue&type=template&id=2e21cd9e&"
import script from "./RiskComponent.vue?vue&type=script&lang=js&"
export * from "./RiskComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports